<!-- Root Vue component -->
<template>
  <v-app>
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
    <app-notifier />
    <app-loader />
  </v-app>
</template>

<script setup>
import AppNotifier from '@/components/system/AppNotifier.vue';
import AppLoader from '@/components/system/AppLoader.vue';
import { useProjectConfig } from '@/composables/useProjectConfig';

// Load project config and apply palette to Vuetify theme
useProjectConfig();
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
